import React, { useEffect, useState } from "react";
import "./headerUserConnected.scss";
import PropTypes from "prop-types";
import { FaAngleDown } from "react-icons/fa";
import Modal from "Components/Modal/Modal";
import { updateAuth } from "Redux/Actions/authActions";
import { updateMenu } from "Redux/Actions/menuActions";
import { connect } from "react-redux";
import "primeicons/primeicons.css";
import { useFetchGet } from "Services/api";
import { useNavigate } from "react-router-dom";
import neutralUser from "assets/neutralUser.png";

// const API_ALUMNI = process.env.REACT_APP_BASE_URL_ALUMNI;
const headerUserConnected = (props) => {
  const navigate = useNavigate();
  const conversationData = useFetchGet(
    `/conversations/user/${props.auth.userConnected.id}`,
    props.auth.token
  );
  const [numberOfNewMessages, setNumberOfNewMessages] = useState(0);

  // Fonction pour aller sur la page de déconnexion du serveur
  const navigateToLogout = () => {
    window.location.href = `${process.env.REACT_APP_BASE_URL_API}/logout`;
  };

  // Supprime les cookies de connexion
  const removeCookies = () => {
    // Suppression des cookies de connexion et de rafraichissement du token
    // - Authentification locale
    document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    // - Shibboleth (commenté car géré par le serveur)
    // document.cookie = "t=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    // document.cookie = "rft=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  };

  // Déconnecte l'utilisateur
  const disconnectUser = () => {
    props.handleAuth({
      isConnected: false,
      token: null,
      userConnected: null,
      universityConnected: {},
      isAdmin: false,
      isCreator: false,
      isValidator: false,
    });
    removeCookies();
    navigateToLogout();
  };

  // Calcule le nombre de conversations où il y a des messages non lus
  // Si le nb de message est > 0 affiche une pastille rouge avec le nb de conversation
  useEffect(() => {
    if (conversationData.loaded) {
      let tempNumberOfNewMessages = 0;
      (props.messages.myConversations.length > 0
        ? props.messages.myConversations
        : conversationData.data
      ).forEach((conversation) => {
        if (
          conversation.messages.some(
            (message) =>
              message.user.id !== props.auth.userConnected.id &&
              message.messageStatus.split("/")[3] == 1
          )
        ) {
          tempNumberOfNewMessages += 1;
        }
        setNumberOfNewMessages(tempNumberOfNewMessages);
      });
    }
  }, [conversationData.loaded, props.messages.myConversations]);
  const [openConnexionInterface, setOpenConnexionInterface] = useState(false);

  const [visibleModal, setVisibleModal] = useState(false);
  return (
    <div className="userConnected">
      <div className="userConnected__right">
        <div className="userConnected__icons">
          <i
            className="pi pi-comments userConnected__icons__icon messages_icon"
            onClick={() => navigate("/messages")}
          >
            {" "}
          </i>
          {numberOfNewMessages > 0 && (
            <div className="message_notification">{numberOfNewMessages}</div>
          )}
        </div>
        <div className="userConnected__right__image_button">
          <button
            onMouseEnter={() => setOpenConnexionInterface(true)}
            onMouseLeave={() => setOpenConnexionInterface(false)}
            className="userConnected__button"
          >
            {props.auth.isConnected && props.auth.userConnected && (
              <>
                <img
                  src={
                    props.auth.userConnected.imageUrl
                      ? props.auth.userConnected.imageUrl
                      : neutralUser
                  }
                  alt="Photo de profil utilisateur"
                  title="Photo de profil utilisateur"
                  className="userConnected__picture"
                  onClick={() => navigate("/profil")}
                />
                {props.auth.userConnected.firstname}
              </>
            )}

            <FaAngleDown />
            {openConnexionInterface && props.auth.userConnected && (
              <div
                className="connexionInterfaceConnected"
                onMouseEnter={() => setOpenConnexionInterface(true)}
                onMouseLeave={() => setOpenConnexionInterface(false)}
              >
                <ul>
                  <li>
                    {props.auth.userConnected.userRoles.some((role) =>
                      role.roleName.includes("ROLE_ETUDIANT")
                    ) && "Étudiant"}
                    {props.auth.isAdmin && "Admin"}
                    {props.auth.userConnected.userRoles.some(
                      (role) => role.roleName == "ROLE_PERSONNEL_UNIVERSITE"
                    ) && "Personnel"}
                    {props.auth.userConnected.userRoles.some(
                      (role) => role.roleName == "ROLE_ALUMNI"
                    ) && "Alumni"}
                  </li>
                  <li
                    onClick={() => {
                      props.handleMenu({
                        activeItemProfilEdit:
                          props.items.itemsProfilEdit.findIndex(
                            (v) => v.label == "Informations personnelles"
                          ),
                      });
                      navigate("/profil-edit");
                    }}
                  >
                    Gérer mon profil
                  </li>
                  {/* {props.auth.userConnected.userRoles.some(
                    (role) =>
                      role.roleName == "ROLE_ADMIN_DU_PORTAIL" ||
                      role.roleName == "ROLE_PERSONNEL_UNIVERSITE"
                  ) &&
                    props.auth.universityConnected.slug ===
                      "pantheon-sorbonne" && (
                      <a
                        href={API_ALUMNI}
                        onClick={() => removeCookies()}
                        className="portail_alumni"
                      >
                        <li>Portail Alumni</li>
                      </a>
                    )} */}
                  <li onClick={() => disconnectUser()}>Se déconnecter</li>
                </ul>
              </div>
            )}
          </button>
          {visibleModal && (
            <Modal
              visible={visibleModal}
              setVisible={setVisibleModal}
              header="Se connecter"
            >
              <form action="/action_page.php">
                <label htmlFor="fname">First name:</label>
                <input type="text" id="fname" name="fname" value="John" />
                <label htmlFor="lname">Last name:</label>
                <input type="text" id="lname" name="lname" value="Doe" />
                <input type="submit" value="Submit" />
              </form>
            </Modal>
          )}
        </div>
      </div>
    </div>
  );
};

headerUserConnected.propTypes = {
  auth: PropTypes.object,
  handleAuth: PropTypes.func,
  items: PropTypes.object,
  messages: PropTypes.object,
  handleMenu: PropTypes.func,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  items: state.items,
  messages: state.messages,
});

const mapDispatchToProps = (dispatch) => ({
  handleAuth: (value) => {
    dispatch(updateAuth(value));
  },
  handleMenu: (value) => {
    dispatch(updateMenu(value));
  },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(headerUserConnected);
